import React from "react"
import Image from "next/image"
import { motion } from "framer-motion"

type props = {
  center?: boolean
  subtitle?: string
  title: string
  caption?: string
  imageDes?: any
  imageMob?: any
}

export const PageHeader: React.FC<props> = (props) => {
  const headAnim = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const textAnim = {
    hidden: { opacity: 0, y: "-8px" },
    show: {
      opacity: 1,
      y: "0",
      transition: {
        ease: "easeOut",
        duration: 0.3,
      },
    },
  }

  const imageAnim = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,

      transition: {
        ease: "easeOut",
        duration: 0.3,
      },
    },
  }

  return (
    <section>
      <motion.div
        className={"wrapper page-header " + (props.center && "page-header-center")}
        variants={headAnim}
        initial='hidden'
        animate='show'
        exit='hidden'
      >
        <div className='details'>
          {props?.subtitle && (
            <motion.h4 variants={textAnim}>{props?.subtitle}</motion.h4>
          )}

          <motion.h1 variants={textAnim}>{props.title}</motion.h1>

          {props?.caption && (
            <motion.p className='body-lg gray-text' variants={textAnim}>
              {props?.caption}
            </motion.p>
          )}
        </div>

        {props?.imageDes && (
          <motion.div className='des image-container' variants={imageAnim}>
            <Image
              src={props.imageDes}
              alt='Page cover'
              layout='responsive'
              objectFit='cover'
              priority
            />
          </motion.div>
        )}

        {props?.imageMob && (
          <motion.div className='mob image-container' variants={imageAnim}>
            <Image
              src={props.imageMob}
              alt='Page cover'
              layout='responsive'
              objectFit='cover'
              priority
            />
          </motion.div>
        )}
      </motion.div>
    </section>
  )
}
